<template>
  <div
    v-if="!userAvatarId"
    :class="[classList, backgroundClass, thumbSizeClass, {'mr-2' : !overrideMargins, 'deleted': isDeleted}]"
    class="Thumb user-badge text-white"
  >
    <template v-if="userName === ''">
      {{'-'}}
    </template>
    <template v-else>
      {{ userName | extractInitialsByName}}
    </template>
  </div>

  <div
    v-else
    :class="[classList, backgroundClass, thumbSizeClass,{ 'mr-2' : !overrideMargins, 'deleted': isDeleted}]"
    class="Thumb user-badge text-white"
  >
    <template v-if="imageSrc">
      <img
        :src="imageSrc"
        alt='avatar'
      >
    </template>
    <template v-else>
      {{ userName | extractInitialsByName}}
    </template>

  </div>

</template>

<script>
export default {
  name: 'UserNameBadge',
  props: {
    userName: {
      type: String,
      required: true
    },
    classList: {
      type: String
    },
    backgroundClass: {
      type: String,
      default: 'bg-secondary'
    },
    userAvatarId: {
      type: [Number, Boolean]
    },
    thumbSizeClass: {
      type: String,
      default: 'Thumb--32'
    },
    overrideMargins: {
      type: Boolean,
      default: false
    },
    isDeleted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFetchinAvatar: false

    }
  },
  computed: {
    resources () {
      return this.$store.getters['ResourcesStore/resources'] || []
    },
    imageSrc () {
      let resource = ''
      if (this.userAvatarId) {
        const userResource = this.resources.find(el => el.id === this.userAvatarId)
        resource = userResource && userResource.resource ? userResource.resource : ''
      }
      return resource
    }
  },
  methods: {
    async fetchAvatar () {
      this.$store.dispatch('ResourcesStore/fetchResource', { id: this.userAvatarId })
    }

  },
  watch: {
    userAvatarId: {
      handler: 'fetchAvatar',
      immediate: true
    }
  }
}
</script>

<style scoped>
.user-badge {
  font-weight: 400 !important;
}
.Thumb--35 {
  height: 35px;
  width: 35px;
}
.deleted {
  opacity: 0.6;
}
</style>
